import APIClient from '../../../../common/services/APIClient';

export const setPackages = (packages) => ({
  type: 'SET_PACKAGES',
  packages,
});

export const setTotalCount = (totalCount) => ({
  type: 'SET_TOTAL_COUNT',
  totalCount,
});

export const toggleFetching = (flag) => ({
  type: 'TOGGLE_PACKAGES_FETCHING',
  flag,
});

export const getChargerPackages = (uuid) => (dispatch) => {
  dispatch(setPackages([]));
  dispatch(toggleFetching(true));
  APIClient.get(`/chargers/${uuid}/packages`)
    .then((resp) => {
      if (resp.data.packagePayloads) {
        dispatch(setPackages(resp.data.packagePayloads));
        dispatch(setTotalCount(resp.data.packagePayloads.length));
      }
      dispatch(toggleFetching(false));
    })
    .catch((err) => {
      console.error(err);
    });
};
